module.exports = __webpack_public_path__ + "static/media/motor-yacht.4c91b71d.svg";